import { useNavigate } from "react-router-dom"
import "../styles/portal/Implementos.css"
import Select from "react-select/base";
import EmConstrucao from "../EmConstrucao";
import Botao from "../utils/Botao";
import { useEffect } from "react";

function Veiculos() {
    /* useEffect(() => {
        getVehiclesAPI(dispositivoEscolhido.deviceID)
        .then(res => {
            if(!res.ok) throw Error("Não conseguiu buscar veiculos deste deviceID");
            return res.json();
        })
        .then(data => {
            setVehicles(data); 
            console.log("painelcontrole.js getVehiclesAPI then then ", data); 
            setTela(telaEnum.veiculos);
        })
        .catch(err => {
            console.log("painelcontrole.js getVEhiclesAPI catch ", err);
        });
    }, []);   */  
    const navigate = useNavigate();
    const handleOnClickVoltar = () => {
        navigate("/portal/home");
    };
    const handleChange = (selectedItems) => {
        console.log(selectedItems);
    }
    const handleOnClickImplemento = () => {
        navigate("/portal/veiculo-detalhe");
    }
    const options = [
        {value: "xxx", label: "tablet01 (id:xxxx)"},
        {value: "yyy", label: "tablet02 (id:yyy)"},
        {value: "zzz", label: "tablet03 (id:zzz)"}
    ];
    const veiculos = [
        {
            "veiculoID": "ccc",
            "nome": "veiculo1"
        },
        {
            "veiculoID": "ddd",
            "nome": "veiculo2"
        },
    ];
    return (
        <div className="implementos-container">
            <div className="implementos-tittle-container">
                {/* <button onClick={() => handleOnClickVoltar()}>Voltar</button> */}
                <Botao handleOnClick={() => handleOnClickVoltar()} estilo={{"width": "100px"}}>Voltar</Botao>
                <div className="tittle">Meus Veiculos</div>
            </div>
            <EmConstrucao />
            {/* <div className="implementos-content-container">
                <div className="implementos-filter-container">
                    <div className="trabalhos-content-filter-dropdown">
                        <h3>Device:</h3>
                        <Select options={options} onChange={handleChange} />
                    </div>
                    <div className="trabalhos-content-filter-filtrarbtn">
                        <button>Filtrar</button>
                    </div>
                </div>
                <div className="implementos-lista-container">
                    {veiculos.map((veiculo) => (
                        <div className="implementos-lista-implemento" key={veiculo.implementoID} onClick={() => handleOnClickImplemento()}>
                        <p>{veiculo.nome}</p>
                    </div>
                    ))}                    
                </div>
            </div> */}
        </div>
    )
}

export default Veiculos
